import { EventType, EventStatus, EventFormat } from '~/types/events';

export default function getEventFormat({
  type,
  status,
}: Record<string, string>) {
  let format: EventFormat | undefined;

  if (type === EventType.OFFLINE && status === EventStatus.UPCOMING) {
    format = EventFormat.IN_PERSON;
  } else if (type === EventType.ONLINE && status === EventStatus.UPCOMING) {
    format = EventFormat.ONLINE;
  } else if (type === EventType.ONLINE && status === EventStatus.ON_DEMAND) {
    format = EventFormat.ON_DEMAND;
  } else if (
    (type === EventType.ONLINE || type === EventType.OFFLINE) &&
    status === EventStatus.ONGOING
  ) {
    format = EventFormat.ONGOING;
  }

  return format;
}
